(() => {
  function initCartForm() {
    const form = document.getElementById('cart');
    const update = document.getElementById('atelier-cart-update');
    if (!form || !update || form.dataset.atelierNativeCart === 'ready') return;
    form.dataset.atelierNativeCart = 'ready';
    form.addEventListener('change', (event) => {
      if (!event.target.matches('input[name="updates[]"]')) return;
      if (!form.reportValidity()) return;
      // Submit all current quantities to Shopify; the returned page contains
      // authoritative totals, discounts and the native checkout form.
      form.requestSubmit(update);
    });
  }
  initCartForm();
  document.addEventListener('shopify:section:load', initCartForm);
})();
